module.exports = __webpack_public_path__ + "img/applea.74949368.svg";